export default {"src":"/_next/static/media/checkmark.01a561a3.svg","height":9,"width":11,"blurWidth":0,"blurHeight":0};